export function formatMeetingDate(dateStr: string): string {
  try {
    const iso = dateStr.includes('T') ? dateStr : `${dateStr}T12:00:00`;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('en-GB', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
}
